// deps
import React, { useState, ReactElement, useCallback, memo } from "react";

// icons
import CommImg from "@payment-ui/icons/CommImg";

// internal deps
import { useEffectOnce } from "@swiggy-private/core-ui";

// helpers
import { showFKCoinsTootip, increaseFKCoinsTooltipShownCounter } from "@payment-ui/helpers/FlipkartSuperCoin";

// constants
import { FK_COINS_TOOLTIP_CONTENT } from "@payment-ui/constants/FlipkartSuperCoins";

// styles
import { StyledTooltip, TooltipIcon, TooltipContainer, TooltipText } from "./styles";

// test id
import { FLIPKART_SUPERCOINS_TOOLTIP_TEST_IDS } from "@swiggy-private/payment-test-ids";

export interface FlipkartSuperCoinToolTipProps {
    isTurboWidget?: boolean;
    onFlipkartToolTipShow?: () => void;
}

function FlipkartSuperCoinToolTip({
    isTurboWidget = false,
    onFlipkartToolTipShow,
}: FlipkartSuperCoinToolTipProps): ReactElement | null {
    const [showTooltip, setShowTooltip] = useState(false);

    const onCloseTooltip = useCallback(() => {
        setShowTooltip(false);
    }, []);

    useEffectOnce(() => {
        if (showFKCoinsTootip(isTurboWidget)) {
            setShowTooltip(true);
            increaseFKCoinsTooltipShownCounter(isTurboWidget);
        }

        onFlipkartToolTipShow && onFlipkartToolTipShow();
    });

    if (!showTooltip) {
        return null;
    }

    const testId = isTurboWidget
        ? FLIPKART_SUPERCOINS_TOOLTIP_TEST_IDS.TURBO
        : FLIPKART_SUPERCOINS_TOOLTIP_TEST_IDS.PAYMENT;

    return (
        <TooltipContainer as="div" isTurboWidget={isTurboWidget} data-testid={testId}>
            <StyledTooltip isTurboWidget={isTurboWidget} onClickClose={onCloseTooltip}>
                <TooltipIcon>
                    <CommImg />
                </TooltipIcon>
                <TooltipText variant="V2.body2.neutral.medium" color="text_inverse_Highest_Emphasis">
                    {FK_COINS_TOOLTIP_CONTENT.TEXT}
                </TooltipText>
            </StyledTooltip>
        </TooltipContainer>
    );
}

export default memo(FlipkartSuperCoinToolTip);
